import { Col, Row } from "react-bootstrap";

function DiscoverFeature(){
    return(
        <>
			<Row className="player-feature p-4 top-title-3 max-width-set">
				<Col xs={12} className="title-sub p-3 ">
					Discover How 3D &amp; AR Can Elevate Your Success
					<div className="bar-break d-flex justify-content-center align-content-center my-2">
						<div className="main-sub"> </div>
					</div>
				</Col>


				<Col xs={12} className="feature-list-dropdown">
				<ul>
					<li>
					<p className="discovery-list">
						<b>Enhanced Brand Visibility:</b> Stand out in a crowded market by utilizing cutting-edge 3D and AR technology to create memorable marketing campaigns and product presentations.
					</p>
					</li>
					<li>
					<p className="discovery-list">
						<b>Improved Sales and Conversions:</b> Boost sales and conversion rates as customers get a deeper, more interactive understanding of your products or services.
					</p>
					</li>
					<li>
					<p className="discovery-list">
						<b>Cost Efficiency:</b> Streamline product demonstrations, training, and marketing efforts by replacing physical materials with dynamic 3D and AR content, reducing costs and environmental impact.
					</p>
					</li>
					<li>
					<p className="discovery-list">
						<b>Immersive Learning:</b> Engage trainees with lifelike 3D and AR simulations for hands-on, memorable learning experiences.
					</p>
					</li>
					<li>
					<p className="discovery-list">
						<b>Interactive Training:</b> Foster better retention through hands-on interaction with 3D models and augmented reality content.
					</p>
					</li>
					<li>
					<p className="discovery-list">
						<b>Flexible Training:</b> Adapt to individual learning styles and preferences with dynamic, interactive 3D content accessible from anywhere.
					</p>
					</li>
				</ul>
				</Col>

			</Row>
        </>
    )
}

export default DiscoverFeature;